import { ref } from 'vue';
import { httpService } from '../services/httpService';
import { log, error as logError } from '../utils/DebugLogger';
import type { Orders_PendingLaudoItemRow } from '../contracts/Orders_PendingLaudoItemRow';

type LaudoType = 'entrada' | 'saida';

const ENDPOINTS: Record<LaudoType, string> = {
  entrada: '/index.php/so/orders/items_pending_entry_laudo',
  saida: '/index.php/so/orders/items_pending_exit_laudo'
};

const RESPONSE_CONTRACTS: Record<LaudoType, 'Orders_ItemsPendingEntryLaudoResponse' | 'Orders_ItemsPendingExitLaudoResponse'> = {
  entrada: 'Orders_ItemsPendingEntryLaudoResponse',
  saida: 'Orders_ItemsPendingExitLaudoResponse'
};

const ERROR_MESSAGES: Record<LaudoType, string> = {
  entrada: 'Erro ao buscar itens pendentes de laudo de entrada',
  saida: 'Erro ao buscar itens pendentes de laudo de saída'
};

export function useSOLaudosPending(type: LaudoType) {
  const isLoading = ref(false);
  const error = ref<string | null>(null);
  const items = ref<Orders_PendingLaudoItemRow[]>([]);

  const fetchPendingItems = async (): Promise<Orders_PendingLaudoItemRow[]> => {
    log('useSOLaudosPending', 'fetchPendingItems', `Fetching pending ${type} laudo items`);
    isLoading.value = true;
    error.value = null;

    try {
      const response = await httpService.get(ENDPOINTS[type], { responseContract: RESPONSE_CONTRACTS[type] });

      if (response.success) {
        items.value = response.dados || [];
        return items.value;
      }

      throw new Error(response.error || ERROR_MESSAGES[type]);
    } catch (err: unknown) {
      logError('useSOLaudosPending', 'fetchPendingItems', `Error fetching pending ${type} laudo items`, err);
      error.value = err instanceof Error ? err.message : String(err);
      throw err;
    } finally {
      isLoading.value = false;
    }
  };

  return { isLoading, error, items, fetchPendingItems };
}
